import React from 'react'
import MapDisplay from './MapDisplay'
import './style.css'

const CONFIGS = {
  tanom: {
    unit: '°C',
    prefixPos: '+',
    prefixNeg: '-',
    imageUrl:
      'https://ta-interaktiv.s3.eu-central-1.amazonaws.com/klima-dashboard/meteoschweiz/maps/tanom/',
    ramp: [
      [7, 'rgb(103, 0, 31)'],
      [6, 'rgb(154, 20, 41)'],
      [5, 'rgb(192, 56, 59)'],
      [4, 'rgb(218, 106, 87)'],
      [3, 'rgb(238, 154, 124)'],
      [2, 'rgb(248, 195, 169)'],
      [1.5, 'rgb(250, 212, 191)'],
      [1, 'rgb(250, 225, 211)'],
      [0.5, 'rgb(248, 235, 227)'],
      [0, 'rgb(242, 239, 238)'],
      [-0.5, 'rgb(232, 238, 242)'],
      [-1, 'rgb(218, 233, 241)'],
      [-1.5, 'rgb(201, 225, 237)'],
      [-2, 'rgb(181, 215, 232)'],
      [-3, 'rgb(133, 188, 217)'],
      [-4, 'rgb(83, 155, 199)'],
      [-5, 'rgb(48, 121, 180)'],
      [-6, 'rgb(25, 86, 147)'],
      [-7, 'rgb(5, 48, 97)']
    ]
  },
  ranom: {
    unit: '%',
    prefixPos: '',
    prefixNeg: '',
    imageUrl:
      'https://ta-interaktiv.s3.eu-central-1.amazonaws.com/klima-dashboard/meteoschweiz/maps/ranom/',
    ramp: [
      [300.0, 'rgb(2,49,78)'],
      [220.0, 'rgb(6,101,167)'],
      [180.0, 'rgb(99,160,193)'],
      [140.0, 'rgb(73,181,149)'],
      [120.0, 'rgb(142,242,169)'],
      [105.0, 'rgb(198,255,198)'],
      [95.0, 'rgb(255,255,255)'],
      [80.0, 'rgb(255,243,177)'],
      [65.0, 'rgb(243,220,147)'],
      [50.0, 'rgb(243,198,121)'],
      [35.0, 'rgb(221,155,89)'],
      [15.0, 'rgb(198,122,55)'],
      [0.0, 'rgb(173,95,36)']
    ]
  }
}

export default function SwissMap({
  mode = 'tanom',
  width,
  progress,
  setProgress,
  endDate,
  started
}) {
  const { ramp, unit, prefixPos, prefixNeg, imageUrl } = CONFIGS[mode]

  return (
    <div className='map' style={{ position: 'relative' }}>
      <MapDisplay
        width={width}
        progress={progress}
        maxWidth={width}
        aspect={0.63}
        setProgress={setProgress}
        imageUrl={imageUrl}
        overlays={['ch-border.svg', 'ch-border.svg']}
        endDate={endDate}
        placeholderImage='ch-placeholder.png'
        started={started}
      />
      <div
        style={{
          position: 'absolute',
          top: 80,
          left: 0,
          fontSize: '0.7rem',
          lineHeight: 0.2
        }}
      >
        {ramp.map(([v, c], i, arr) => (
          <div>
            <div
              style={{
                width: 6,
                height: 6,
                background: c,
                display: 'inline-block',
                marginRight: 5
              }}
            />
            {[
              ramp[0][0],
              ramp[(ramp.length - 1) / 2][0],
              ramp[ramp.length - 1][0]
            ].includes(v) &&
              `${v >= 0 ? prefixPos : prefixNeg}${Math.abs(v)}${unit}`}
          </div>
        ))}
      </div>
      <div style={{ fontSize: '0.7rem' }}>Source: MétéoSuisse</div>
    </div>
  )
}
